import React, { Component } from 'react'

export class Leveldetails extends Component {
    render() {
        return (
<div className="box">
   <div className="box-body">
      <div className="box-header">
         <h3 className="box-title">L2/L3/L4</h3>
      </div>
      <div className="box-body">
         <div className="col-md-12">
            <form>
               <div className="col-md-4">
                  <div className="form-group">
                     <label>L2/L3/L4</label> 
                     <select className="form-control" name="lowest_type">
                        <option value="">Select Type</option>
                     </select>
                  </div>
               </div>
               <div className="col-md-4">
                  <div className="form-group">
                     <label>Quoted Amount by Contractor</label> 
                     <input className="form-control" type="text" name="quoted_amount" />
                  </div>
               </div>
               <div className="col-md-4">
                  <div className="form-group">
                     <label>Amount Above/Below w.r.t Tender</label> 
                     <input className="form-control" type="text" name="tendamount" />
                  </div>
               </div>
               <div className="col-md-4">
                  <div className="form-group">
                     <label>% Above / Below w.r.t Tender</label> 
                     <input className="form-control" type="text" name="above_below_tender" />
                  </div>
               </div>
               <div className="col-md-4">
                  <div className="form-group">
                     <label>Name of Contractor</label> 
                     <select className="form-control select2" name="agencyid">
                     </select>
                  </div>
               </div>
               <div className="col-md-4" style={{padding:'2%'}}>	   
                  <input type="submit" name="ini_submit" value="Save" className="btn btn-info" />
               </div>
            </form>
         </div>
         <div className="col-md-12">
            <table className="table table-bordered">
            <thead>
               <tr>
                  <th className="text-center">SR.NO.</th>
                  <th className="text-center">L2/L3/L4 Type</th>
                  <th className="text-center">Quoted Amount by Contractor</th>
                  <th className="text-center">Name of Contractor</th>
                  <th className="text-center">Edit</th>
               </tr>
               </thead>
            </table>
         </div>
      </div>
   </div>
</div>
        )
    }
}

export default Leveldetails
